import React, { useState } from "react";
import { db } from "../../firebase/Firebase";
import { doc, updateDoc, getDoc, increment } from "firebase/firestore";
import "./balanceTopUp.css";

const BalanceTopUp = () => {
  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleTopUp = async () => {
    if (userId && amount > 0) {
      setIsLoading(true);
      setMessage("");
      try {
        const userRef = doc(db, "users", userId);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const currentBalance = userSnap.data().balance || 0;

          await updateDoc(userRef, { balance: increment(amount) });
          setMessage(
            `Successfully topped up $${amount}. New balance: $${
              currentBalance + amount
            }`
          );
        } else {
          setMessage("User not found!");
        }
      } catch (error) {
        console.error("Error:", error.message || error);
        setMessage(
          `Error topping up balance: ${error.message || "Unknown error"}`
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setMessage("Please provide a valid user ID and amount.");
    }
  };

  return (
    <div className="balanceTopUpPage">
      <h2>Balance Top-Up</h2>
      <input
        type="text"
        placeholder="User ID"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
      />
      <input
        type="number"
        placeholder="Amount"
        value={amount}
        onChange={(e) => setAmount(Number(e.target.value))}
      />
      <button onClick={handleTopUp} disabled={isLoading}>
        {isLoading ? "Processing..." : "Top Up"}
      </button>

      {message && <p>{message}</p>}
    </div>
  );
};

export default BalanceTopUp;
